<template>
  <v-app-bar
    app
    color="rgba(255,255,255,0.7)"
    elevate-on-scroll
    height="80"
    class="backdrop-blur"
  >
    <v-container class="py-0 fill-height">
      <router-link to="/" class="text-decoration-none d-flex align-center mr-8">
        <div class="d-flex flex-column">
          <span
            class="text-h5 font-weight-bold grey--text text--darken-3 leading-tight"
          >
            Happy Harbour
          </span>
          <!-- <span class="caption deep-purple--text font-weight-medium ls-1">
            Private Theater & Cafe
          </span> -->
        </div>
      </router-link>

      <v-spacer></v-spacer>

      <div class="d-none d-md-flex align-center">
        <app-menu class="mr-4"></app-menu>

        <v-btn
          :to="{ name: 'BookNow' }"
          rounded
          large
          elevation="4"
          class="gradient-btn white--text px-6"
        >
          Book Now
        </v-btn>
      </div>

      <div class="d-flex d-md-none align-center">
        <!-- <v-btn
          :to="{ name: 'BookNow' }"
          rounded
          elevation="3"
          class="gradient-btn white--text mr-0"
        >
          Book Now
        </v-btn> -->
        <v-app-bar-nav-icon
          color="primary"
          class="d-lg-none d-md-none"
          @click="$emit('toggleDrawer')"
        ></v-app-bar-nav-icon>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import AppMenu from "@/components/Menus.vue";

export default {
  name: "AppHeader",
  components: {
    AppMenu,
  },
};
</script>

<style scoped>
/* Glassmorphism Effect */
.backdrop-blur {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important; */
}

/* Typography Helpers */
.leading-tight {
  line-height: 1.1;
}
.ls-1 {
  letter-spacing: 1px;
}

/* Matching Gradient Button */
.gradient-btn {
  background: linear-gradient(45deg, #6200ea, #9575cd);
  transition: opacity 0.2s;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.gradient-btn:hover {
  opacity: 0.9;
}
</style>
